var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-483 -430)"},[React.createElement("g",{"transform":"translate(483 430)","fill":"none","stroke":"#000","strokeWidth":"2","key":0},React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"12.5","fill":"none"})),React.createElement("line",{"y2":"9.79","transform":"translate(496.5 438.5)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeWidth":"2","key":1}),React.createElement("line",{"x1":"10","transform":"translate(491.5 443.5)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeWidth":"2","key":2})]));
}

Plus.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27"};

module.exports = Plus;

Plus.default = Plus;
